/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ContactMethodConsent/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ContactMethodConsent({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ContactInput/ContactMethodConsent",
  onChange
  
}) {
  let isMedia = useIsMedia()
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let contactDetailsSelectedAllowconsentValueData = fromData.useDataValue({ viewPath,
context: 'contactDetails',
path: 'selected.allowConsent',
})
let contactDetailsSelectedAllowconsentChangeData = fromData.useDataChange({ viewPath,
context: 'contactDetails',
path: 'selected.allowConsent',
})
let dtCheckboxStrokeBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.stroke.brand.selected'
        })
let dtCheckboxBackgroundcolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.backgroundColor.brand.selected'
        })
let dtCheckboxBordercolorBrandSelected = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.selected'
        })
let dtCheckboxBordercolorBrandHovered = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'Checkbox.borderColor.brand.hovered'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let widgetSettingsConsentoptinValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'settings.consentOptin',
})
let widgetDivisionNameValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'division_name',
})
let widgetParentCompanyNameValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'parent_company_name',
})
let widgetLocationNameValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'location_name',
})
let aggregateData = fromHelpers.getText(widgetSettingsConsentoptinValueData, widgetDivisionNameValueData, widgetParentCompanyNameValueData, widgetLocationNameValueData)
  return (<React.Fragment
>
<div
  data-testid="ContactMethodConsent.Horizontal"
  data-view-path={viewPath}
 style={{'--jc-1-1HfefR': isMedia.mobile ? "space-evenly" : "space-between",'--mb-2-1HfefR': isMedia.mobile ? typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS : "0px"}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="ContactMethodConsent.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 marginTop={dtSpaceS}
 marginRight={dtSpaceS}
 data="contactDetails.selected.allowConsent"
 value={contactDetailsSelectedAllowconsentValueData}
 onChange={contactDetailsSelectedAllowconsentChangeData}
 strokeSelected={dtCheckboxStrokeBrandSelected}
 backgroundColorSelected={dtCheckboxBackgroundcolorBrandSelected}
 borderColorSelected={dtCheckboxBordercolorBrandSelected}
 borderColorHovered={dtCheckboxBordercolorBrandHovered}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 alignSelf="center"
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 marginLeft={dtSpaceXs}
 text="Receive SMS appointment reminders and service updates"
/>
</React.Fragment>
)}
</TysiaCheckbox>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 data="widget.settings.consentOptin"
 data="widget.division_name"
 data="widget.parent_company_name"
 data="widget.location_name"
 aggregate="helpers.js getText"
 text={aggregateData}
/>
</div>
</div>
{children}
</React.Fragment>)
}